var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslateLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2497 4.74967H23.7497V7.91634H20.5656C20.4643 9.92236 19.9401 11.8843 19.0274 13.6735C18.1146 15.4627 16.834 17.0388 15.2693 18.2983L18.3774 20.6764L16.4553 23.1908L12.6663 20.2933L6.50243 25.0068L4.58026 22.4925L10.0633 18.2983C8.49872 17.0388 7.21804 15.4627 6.30529 13.6735C5.39255 11.8843 4.86835 9.92236 4.76709 7.91634H1.58301V4.74967H11.083V1.58301H14.2497V4.74967ZM12.6663 16.308L13.0653 16.0024C14.3219 15.0415 15.3582 13.8227 16.1046 12.428C16.851 11.0332 17.2901 9.4949 17.3926 7.91634H7.94009C8.04255 9.4949 8.48173 11.0332 9.22811 12.428C9.9745 13.8227 11.0108 15.0415 12.2673 16.0024L12.6663 16.308Z",
    fill: "#8FBFFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6989 17.4165H23.551L23.1932 18.5074L17.4932 35.9241L20.5031 36.9089L21.993 32.3568H30.2548L31.7432 36.9089L34.7531 35.9241L29.0531 18.5074L28.6968 17.4165H24.6989ZM29.2177 29.1902L26.401 20.5832H25.8468L23.0285 29.1902H29.2177Z",
    fill: "#2859C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateLogo);
export default __webpack_public_path__ + "static/media/translate-logo.4fde9b19cceb46f89ce8e76252a18f66.svg";
export { ForwardRef as ReactComponent };